import React from "react"
import LoadingBlock from "../../components/loader/LoadingBlock";
import ErrorBadGateway from "../../components/error/ErrorBadGateway";
import {useGetSelfEmployeeQuery} from "../../store/api/configurationApi";
import {useGetBranchesQuery} from "../../store/api/organizationApi";
import ErrorAccessDenied from "../../components/error/ErrorAccessDenied";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const PermissionProvider: React.FC<PermissionProviderProps> = ({children}) => {

    const {isLoading, isError, data} = useGetSelfEmployeeQuery()
    const {isLoading: isBranchesLoading} = useGetBranchesQuery()
    
    if (isLoading || isBranchesLoading) return <LoadingBlock/>
    if (isError) return <ErrorBadGateway/>
    if (!data?.data?.permissions?.can_read_booking) return <ErrorAccessDenied/>

    return (
        <>
            {children}
        </>
    )
}

export default PermissionProvider
